import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { AppHeader, AppLayout, AppSidebar } from "../Layout";
import { clearContentSlice, getDitaContent, selectDitaContent } from "../Content/ContentSlice";
import FAQContent from "./FAQContent";

const FAQPage = () => {
  const content = useSelector(selectDitaContent);
  const dispatch = useDispatch();
  
  const faqContent = getDitaContent('Changes/FAQs/TG_faqs-non-corporate.ditamap', content, dispatch);

  useEffect(() => {
    return () => {
      dispatch(clearContentSlice());
    };
  }, [dispatch]);

  return (
    <AppLayout
      appSidebar={<AppSidebar />}
      appHeader={<AppHeader />}
      useMainContentWrapper={false}
    >
      <FAQContent faqContent={faqContent}></FAQContent>
    </AppLayout>
  );
};

export default FAQPage;


